import type { CategoryNode } from "../Api/Categories/categories";

export function countUndisciplinedLeaves(categoriesFlatTree: Record<number, CategoryNode[]>): number {
    const allNodes = Object.values(categoriesFlatTree)
        .flat()
        .filter(n => !n.extendingNode);

    const nodeById = new Map(allNodes.map(n => [n.id, n]));

    const hasEffectiveDiscipline = (nodeId: number): boolean => {
        let current = nodeById.get(nodeId);
        while (current) {
            if (current.disciplineType.name !== null) {
                return true;
            }
            if (current.parentId === null) {
                break;
            }
            current = nodeById.get(current.parentId);
        }
        return false;
    };

    const leafNodes = allNodes.filter(n => !categoriesFlatTree[n.id]?.length);
    const hasOnlyRootLeaf = leafNodes.length === 1 && leafNodes[0].parentId === null;

    if (hasOnlyRootLeaf) {
        return 0;
    }

    return leafNodes.filter(n => !hasEffectiveDiscipline(n.id)).length;
}
